import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {MainComponent} from './main/main.component';
import {APP_CONTAINER_SETTINGS, AppContainerModule, LanguageService, MydocmaServiceWorkerModule} from '@mydocma/app-container';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {ProjectModule, ProjectStructureService} from '@mydocma/project';
import {CustomerModule} from '@mydocma/customer';
import {AuthModule, AUTHSETTINGS, AUTHSTORAGE} from '@mydocma/auth';
import {environment} from '../environments/environment';
import {MediaQueryService, MediatorService, MYDOCMASETTINGS, Retry504Interceptor} from '@mydocma/core';
import {HttpClient, HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {ModuleTranslateLoader} from '@larscom/ngx-translate-module-loader';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions, MatTooltipModule} from '@angular/material/tooltip';
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en-GB';
import localeIT from '@angular/common/locales/it';
import {TaskFileDownloadService, TaskHttpService, TaskService, TASK_CONFIG, WEBSOCKET_CONFIG as MYDOCMA_WEBSOCKET_CONFIG} from '@mydocma/task';
import {MydocmaFloatingActionButtonModule} from '@mydocma/component-library/src/lib/floating-action-button';
import {MydocmaDynamicFormModule} from '@mydocma/dynamic-form';
import {ImageViewerModule} from '@mydocma/component-library/src/lib/image-viewer';
import {
    RpImageViewerService
} from 'projects/mydocma-rp/src/lib/rp-daily-report/daily-report/daily-file/rp-image-viewer.service';
import {MatButtonModule} from "@angular/material/button";
import {MatToolbarModule} from "@angular/material/toolbar";
import {LoaderModule, ResizeModule} from '@mydocma/component-library';
import {DragDropFileUploadModule} from "@mydocma/component-library/src/lib/drag-drop-file-upload";
import { MydocmaLoggerModule } from '@mydocma/common/src/lib/logger';

// export class MyHammerConfig extends HammerGestureConfig  {
//   overrides = <any>{
//       'swipe': {velocity: 0.1, threshold: 1}, // override default settings
//   }
// }

export const matTooltipCustomConfig: MatTooltipDefaultOptions = {
    showDelay: 5,
    hideDelay: 5,
    touchendHideDelay: 5,
};

// @Injectable()
// export class MyHammerConfig extends HammerGestureConfig {
//     // buildHammer(element: HTMLElement) {
//     //     let mc = <HammerManager>super.buildHammer(element);
//     //     mc.set({ touchAction: "pan-y" });
//     //     // Your other configurations
//     //     mc.get('swipe').set({ velocity: 0.1, threshold: 1,direction: Hammer.DIRECTION_ALL });
//     //     return mc;
//     // }

//     buildHammer(element: HTMLElement): HammerManager {
//         const MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
//         const SUPPORT_TOUCH = "ontouchstart" in window;
//         const SUPPORT_ONLY_TOUCH =
//             SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
//         return new Hammer.Manager(element, {
//             touchAction: "auto",
//             inputClass: SUPPORT_ONLY_TOUCH
//                 ? Hammer.TouchInput
//                 : Hammer.PointerEventInput,

//             recognizers: [
//                 [
//                     Hammer.Swipe,
//                     {
//                         direction: Hammer.DIRECTION_ALL,
//                         velocity: 0.3,
//                         threshold: 10,
//                     },
//                 ],
//             ],
//         });
//     }
// }

export function createTranslateLoader(http: HttpClient) {
    const baseTranslateUrl = "./assets/i18n";

    return new ModuleTranslateLoader(http, {
        modules: [
            {
                moduleName: "app-container",
                baseTranslateUrl,
                //fileType: FileType.JSON,
            },
            {
                moduleName: "project",
                baseTranslateUrl,
                //fileType: FileType.JSON,
            },
            {
                moduleName: "customer",
                baseTranslateUrl,
                //fileType: FileType.JSON,
            },
            {
                moduleName: "report", baseTranslateUrl,
                //fileType: FileType.JSON
            },
            {
                moduleName: "comp-lib",
                baseTranslateUrl,
                //fileType: FileType.JSON,
            },
            {
                moduleName: "rp",
                baseTranslateUrl,
                //fileType: FileType.JSON
            },
            {
                moduleName: "form",
                baseTranslateUrl,
                //fileType: FileType.JSON
            },
            {
                moduleName: "pix-common",
                baseTranslateUrl,
                //fileType: FileType.JSON
            }
        ],
    });
}

@NgModule({
    declarations: [AppComponent, MainComponent],
    imports: [
        MydocmaLoggerModule.forRoot(),
        AppRoutingModule,
        HttpClientModule,
        BrowserModule,
        BrowserAnimationsModule,
        LoaderModule,
        MatButtonModule,
        MatToolbarModule,
        ReactiveFormsModule,
        AppContainerModule,
        MydocmaServiceWorkerModule,
        MatTooltipModule,
        MydocmaFloatingActionButtonModule,
        MydocmaDynamicFormModule,
        ImageViewerModule,
        AuthModule.forRoot(),
        CustomerModule.forRoot(),
        ProjectModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        DragDropFileUploadModule,
        ResizeModule,
    ],
    providers: [
        MediatorService,
        MediaQueryService,
        RpImageViewerService,
        TaskService,
        TaskHttpService,
        TaskFileDownloadService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: Retry504Interceptor,
            multi: true
        },
        ProjectStructureService
    ],
    exports: [
        MydocmaFloatingActionButtonModule,
        MydocmaDynamicFormModule
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(
        private translate: TranslateService,
        private languageService: LanguageService
    ) {
        this.languageService.setLanguages([
            {id: "en", name: "English"},
            {id: "de", name: "Deutsch"},
            {id: "it", name: "Italiano"}
        ]);

        registerLocaleData(localeDE, "de");
        registerLocaleData(localeIT, "it");

        localeEN[10][1] = "dd/MM/yyyy";
        localeEN[10][0] = "dd/MM/yy";
        registerLocaleData(localeEN, "en");

        this.translate.addLangs(["en", "de","it"]);
        this.translate.setDefaultLang("de");
        this.translate.use("de");
    }
}
